import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import ReCAPTCHA from "react-google-recaptcha";
import { useRef } from "react";
import { useTranslation } from 'react-i18next'; // 翻訳用
import { Helmet } from 'react-helmet-async'; // SEO用メタタグ
import LanguageSwitcher from './components/LanguageSwitcher'; // LanguageSwitcherをインポート

// 画像をインポート
import img1 from './images/texasguitaristyuzukikondo1.png';
import img2 from './images/texasguitaristyuzukikondo6.png';
import img3 from './images/texasguitaristyuzukikondo4.png';
import img4 from './images/texasguitaristyuzukikondo2.png';
import img5 from './images/texasguitaristyuzukikondo3.png';
import img6 from './images/texasguitaristyuzukikondo5.png';
import img7 from './images/whitesands1.png';
import img8 from './images/whitesands2.png';

function App() {
  const recaptchaRef = useRef(null);
  const { t } = useTranslation(); // 翻訳関数を取得

  const handleReCAPTCHA = (token) => {
    console.log("reCAPTCHA token:", token);
    alert("Verification successful!");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (recaptchaRef.current) {
      const token = await recaptchaRef.current.executeAsync(); // トークンを取得
      const form = e.target;
      const formData = new FormData(form);
      formData.append("g-recaptcha-response", token); // トークンを追加

      try {
        const response = await fetch("https://formspree.io/f/xrbkqdek", {
          method: "POST",
          body: formData,
          headers: {
            "Accept": "application/json"
          }
        });
        if (response.ok) {
          alert("Message sent successfully!");
          form.reset(); // フォームをリセット
        } else {
          alert("Failed to send message.");
        }
      } catch (error) {
        console.error("Error:", error);
        alert("An error occurred.");
      }
    }
  };

  return (
    <div className="App">
      <Helmet>
        <title>{t('home.title')}</title>
        <meta name="description" content={t('home.description1')} />
        <meta property="og:title" content={t('home.title')} />
        <meta property="og:description" content={t('home.description1')} />
        <meta property="og:image" content="%PUBLIC_URL%/og-image.jpg" />
        <meta property="og:url" content="https://yuzukikondo.com" />
        <meta name="twitter:title" content={t('home.title')} />
        <meta name="twitter:description" content={t('home.description1')} />
        <meta name="twitter:image" content="%PUBLIC_URL%/og-image.jpg" />
        <link rel="alternate" href="https://yuzukikondo.com" hreflang="en" />
        <link rel="alternate" href="https://yuzukikondo.com/ja" hreflang="ja" />
        {/* Google Analyticsスクリプト */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-G89CSW7GKL"></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'YOUR_MEASUREMENT_ID');
          `}
        </script>
      </Helmet>

      <header>
        <nav className="navbar navbar-expand-lg navbar-custom">
          <div className="container">
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse justify-content-between" id="navbarNav">
              <ul className="navbar-nav">
                <li className="nav-item"><a className="nav-link" href="#hero">{t('nav.home')}</a></li>
                <li className="nav-item"><a className="nav-link" href="#bio">{t('nav.bio')}</a></li>
                <li className="nav-item"><a className="nav-link" href="#multimedia">{t('nav.multimedia')}</a></li>
                <li className="nav-item"><a className="nav-link" href="#gallery">{t('nav.gallery')}</a></li>
                <li className="nav-item"><a className="nav-link" href="#lessons">{t('nav.lessons')}</a></li>
                <li className="nav-item"><a className="nav-link" href="#contact">{t('nav.contact')}</a></li>
              </ul>
              <LanguageSwitcher />
            </div>
          </div>
        </nav>
      </header>

      <section id="hero" className="hero py-5 bg-light">
        <div className="coming-soon-bottom-right">
          {t('home.coming_soon')}
        </div>
        <div className="container overlay text-center">
          <h2>{t('home.subtitle')}</h2>
          <h1>{t('home.title')}</h1>
          <p>{t('home.description1')}</p>
          <p>{t('home.description2')}</p>
          <p>{t('home.description3')}</p>
        </div>
      </section>

      <div className="notes-container">
        {[...Array(12)].map((_, i) => (
          <span
            key={i}
            className="note"
            style={{
              left: `${70 + Math.random() * 25}%`,
              animationDelay: `${Math.random() * 5}s`,
              fontSize: `${Math.random() * 20 + 25}px`,
              animationDuration: `${12 + Math.random() * 6}s`,
            }}
          >
            ♪
          </span>
        ))}
      </div>

      <section id="bio" className="bio py-5">
        <div className="container bio-container">
          <h2>{t('bio.title')}</h2>
          <p>{t('bio.paragraph1')}</p>
          <p>{t('bio.paragraph2')}</p>
          <p>{t('bio.paragraph3')}</p>
          <p>{t('bio.paragraph4')}</p>
          <p>{t('bio.paragraph5')}</p>
        </div>
      </section>

      <section id="multimedia" className="multimedia py-5 bg-light">
        <div className="container multimedia-container">
          <h2>{t('multimedia.title')}</h2>
          <div className="d-flex flex-wrap justify-content-center gap-3 video-wrapper">
            <iframe
              width="480"
              height="270"
              src="https://www.youtube.com/embed/mddjTcNCJJw"
              frameBorder="0"
              allowFullScreen
              title={t('multimedia.item1')}
            ></iframe>
            <iframe
              width="480"
              height="270"
              src="https://www.youtube.com/embed/CK-Bffa6s0U"
              frameBorder="0"
              allowFullScreen
              title={t('multimedia.item2')}
            ></iframe>
          </div>
        </div>
      </section>

      <section id="gallery" className="gallery-section">
        <div className="container">
          <h2>{t('gallery.title')}</h2>
          <div className="gallery-grid">
            <img src={img1} alt={t('gallery.image1_alt')} />
            <img src={img2} alt={t('gallery.image2_alt')} />
            <img src={img3} alt={t('gallery.image3_alt')} />
            <img src={img4} alt={t('gallery.image4_alt')} />
            <img src={img5} alt={t('gallery.image5_alt')} />
            <img src={img6} alt={t('gallery.image6_alt')} />
            <img src={img7} alt={t('gallery.image7_alt')} />
            <img src={img8} alt={t('gallery.image8_alt')} />
          </div>
        </div>
      </section>

      <section id="lessons" className="guitar-lessons py-5 bg-light">
        <div className="container">
          <div className="coming-soon-top mb-3">
            {t('lessons.coming_soon_top')}
          </div>
          <div className="guitar-lessons-container">
            <h2>{t('lessons.title')}</h2>
            <p>{t('lessons.description1')}</p>
            <p>{t('lessons.description2')}</p>
            <p>{t('lessons.description3')}</p>
            <p>{t('lessons.description4')}</p>
            <p>{t('lessons.description5')}</p>
            <div className="lesson-types d-flex flex-wrap gap-4 justify-content-center mt-4">
              <div className="lesson-box border rounded p-3 flex-grow-1" style={{ minWidth: '280px' }}>
                <h3>{t('lessons.private.title')}</h3>
                <p className="price h4">{t('lessons.private.price')}</p>
                <p><strong>{t('lessons.private.description1')}</strong> <span>{t('lessons.private.description2')}</span></p>
                <p><strong>{t('lessons.private.description3')}</strong> <span>{t('lessons.private.description4')}</span></p>
                <p><strong>{t('lessons.private.description5')}</strong> <span>{t('lessons.private.description6')}</span></p>
                <p><strong>{t('lessons.private.description7')}</strong> <span>{t('lessons.private.description8')}</span></p>
              </div>
              <div className="lesson-box border rounded p-3 flex-grow-1" style={{ minWidth: '280px' }}>
                <h3>{t('lessons.group.title')}</h3>
                <p className="price h4">{t('lessons.group.price')}</p>
                <p><strong>{t('lessons.group.description1')}</strong> <span>{t('lessons.group.description2')}</span></p>
                <p><strong>{t('lessons.group.description3')}</strong> <span>{t('lessons.group.description4')}</span></p>
                <p><strong>{t('lessons.group.description5')}</strong> <span>{t('lessons.group.description6')}</span></p>
                <p><strong>{t('lessons.group.description7')}</strong> <span>{t('lessons.group.description8')}</span></p>
              </div>
              <div className="lesson-box border rounded p-3 flex-grow-1" style={{ minWidth: '280px' }}>
                <h3>{t('lessons.performance.title')}</h3>
                <p className="price h4">{t('lessons.performance.price')}</p>
                <p><strong>{t('lessons.performance.description1')}</strong> <span>{t('lessons.performance.description2')}</span></p>
                <p><strong>{t('lessons.performance.description3')}</strong> <span>{t('lessons.performance.description4')}</span></p>
                <p><strong>{t('lessons.performance.description5')}</strong> <span>{t('lessons.performance.description6')}</span></p>
              </div>
            </div>
          </div>
          <div className="coming-soon-bottom mt-4 text-center">
            {t('lessons.coming_soon_bottom')}
          </div>
        </div>
      </section>

      <section id="contact" className="contact py-5">
        <div className="container">
          <h2>{t('contact.title')}</h2>
          <div className="contact-socials mb-3">
            <a
              href="https://www.instagram.com/yuzuki.kondo?igsh=MW9rNGpqbTh3N3Bucw%3D%3D&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon me-3"
              aria-label="Instagram"
            >
              <i className="fab fa-instagram fa-2x"></i>
            </a>
            <a
              href="https://youtube.com/@yuzukikondo?si=thBiiLnauVFCNAyL"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="YouTube"
            >
              <i className="fab fa-youtube fa-2x"></i>
            </a>
          </div>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="mb-3">
              <input type="text" name="firstName" placeholder={t('contact.firstName')} className="form-control" />
            </div>
            <div className="mb-3">
              <input type="text" name="lastName" placeholder={t('contact.lastName')} className="form-control" />
            </div>
            <div className="mb-3">
              <input type="email" name="email" placeholder={t('contact.email')} required className="form-control" />
            </div>
            <div className="mb-3">
              <textarea name="message" placeholder={t('contact.message')} className="form-control" rows="4"></textarea>
            </div>
            <div className="button-wrapper text-center">
              <button type="submit" className="btn btn-primary">
                {t('contact.send')}
              </button>
            </div>
            <ReCAPTCHA
              sitekey="6LcGClkrAAAAAE85BRcTmkPyFTn3xOH7uRCT99Mh" // Googleから取得したSite Keyに置き換え
              size="invisible" // invisibleでバッジを最小化、visibleにすればマークが目立つ
              ref={recaptchaRef}
              onChange={handleReCAPTCHA}
              badge="bottomright" // バッジ位置（invisibleでも表示される）
            />
          </form>
        </div>
      </section>

      <footer className="footer bg-light py-3 mt-5">
        <div className="container footer-container text-center">
          <p className="mb-1">{t('footer.text')}</p>
        </div>
      </footer>
    </div>
  );
}

export default App;